import { sendRequest } from 'lib/apis/core';
import { QueryClient, useQuery } from 'react-query';
import { PdpEndPointV2, PdpType } from '.';

export const getPdpSingle = (id: string) => {
  return sendRequest<PdpType.NewPdpSingleResponse>({
    url: PdpEndPointV2.PDP_SINGLE(id) ,
    version:"v2"
  });
};

export const usePdpSingleQuery = (id: string) => {
  return useQuery([PdpEndPointV2.PDP_SINGLE(id), id], () =>
    getPdpSingle(id).then((res) => res.data)
  );
};

export const getPdpSinglePrefetch = (queryClient: QueryClient, id: string) => {
  return queryClient.fetchQuery([PdpEndPointV2.PDP_SINGLE(id), id], () =>
    getPdpSingle(id).then((res) => res.data)
  );
};

export const getPdpContactInfo = (
  id: string,
  mode: string = 'ENCODE_DESKTOP_VIEW'
) => {
  return sendRequest<PdpType.PdpContactInfo>({
    url: PdpEndPointV2.PDP_CONTACT_INFO(id),
    version:"v2"
  });
};

export const usePdpContactInfoQuery = (
  id: string,
  mode: string = 'ENCODE_DESKTOP_VIEW'
) => {
  return useQuery([PdpEndPointV2.PDP_CONTACT_INFO(id), id, mode], () =>
    getPdpContactInfo(id, mode).then((res) => res.data)
  );
};

export const getPdpContactInfoPrefetch = (
  queryClient: QueryClient,
  id: string,
  mode: string = 'ENCODE_DESKTOP_VIEW'
) => {
  return queryClient.fetchQuery([PdpEndPointV2.PDP_CONTACT_INFO(id), id, mode], () =>
    getPdpContactInfo(id, mode).then((res) => res.data)
  );
};

export const getSimilarListing = (id: string) => {
  return sendRequest<PdpType.NewSimilarListingResponse>({
    url: PdpEndPointV2.SIMILAR(id),
    version: "v2"
  });
};

export const similarListingPrefetch = (
  queryClient: QueryClient,
  id: string
) => {
  return queryClient.fetchQuery([PdpEndPointV2.SIMILAR(id), id], () => {
    return getSimilarListing(id).then((res) => res.data);
  });
};

export const useSimilarListingQuery = (id: string) => {
  return useQuery([PdpEndPointV2.SIMILAR(id), id], () => {
    return getSimilarListing(id).then((res) => res.data);
  });
};

export const trackPdp = (id: string) => {
  return sendRequest({
    method: "put",
    url: PdpEndPointV2.TRACK(id),
    version: "v2"
  });
};

export const useTrackQuery = (id: string) => {
  return useQuery([PdpEndPointV2.TRACK(id)], () =>
    trackPdp(id).then((res) => res.data)
  );
};
